import { useMemo, useRef } from 'react';

import { createTheme } from './theme';

import type { Theme } from '../types';
import type { ThemeMode } from './foundation';

export function useCachedTheme(themeMode: ThemeMode) {
  const themes = useRef<Record<string, Theme>>({});
  const theme = useMemo(() => {
    if (!themes.current[themeMode]) {
      themes.current[themeMode] = createTheme(themeMode);
    }
    return themes.current[themeMode];
  }, [themeMode]);
  return theme;
}
